"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var moment_1 = __importDefault(require("moment"));
var index_1 = __importDefault(require("../../../../index"));
var Button_1 = __importDefault(require("../../../../Elements/Button"));
var schema_1 = __importDefault(require("./schema"));
var Formik_1 = __importDefault(require("../../../../Elements/Date/Picker/Formik"));
var Formik_2 = __importDefault(require("../../../../Elements/Radio/Group/Formik"));
var FormikConditionalField_1 = __importDefault(require("../../../../Elements/FormikConditionalField"));
var CreateRouteSettings = function (_a) {
    var mutation = _a.mutation, mutationVariablesFormatter = _a.mutationVariablesFormatter, projectSelect = _a.projectSelect, wasteFractionSelect = _a.wasteFractionSelect, containerTypeSelect = _a.containerTypeSelect, depotStartSelect = _a.depotStartSelect, depotEndSelect = _a.depotEndSelect, wasteStationSelect = _a.wasteStationSelect, driverSelect = _a.driverSelect, vehicleSelect = _a.vehicleSelect, _b = _a.initialValues, initialValues = _b === void 0 ? {} : _b, onSuccess = _a.onSuccess;
    var ROUTE_TYPES = [
        { label: "Recurring", value: "rec" },
        { label: "One-time", value: "one" },
    ];
    var SCHEDULES = [
        { label: "Daily", value: "daily" },
        { label: "Weekly", value: "weekly" },
        { label: "Monthly", value: "monthly" },
    ];
    return (react_1.default.createElement(index_1.default, { mutation: mutation, mutationVariablesFormatter: mutationVariablesFormatter, onSuccess: onSuccess, formikProps: {
            initialValues: initialValues,
            validationSchema: schema_1.default,
            onSubmit: function () { return console.log("not-used"); },
        } }, function (_a) {
        var isSubmitting = _a.isSubmitting, submitForm = _a.submitForm;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Formik_2.default, { antd: {
                    label: "Type",
                    required: true,
                    labelCol: { span: 24, offset: 0 },
                }, defaultValue: "rec", options: ROUTE_TYPES, optionType: "button", name: "routeType", buttonStyle: "solid" }),
            react_1.default.createElement(FormikConditionalField_1.default, { shouldShow: function (values) { return values.routeType === "one"; } },
                react_1.default.createElement(Formik_1.default, { antd: {
                        required: true,
                        label: "Date",
                        labelCol: { span: 24, offset: 0 },
                    }, disabledDate: function (currentDate) {
                        return currentDate < moment_1.default();
                    }, name: "scheduledDay", style: { display: "grid" } })),
            react_1.default.createElement(FormikConditionalField_1.default, { shouldShow: function (values) { return values.routeType !== "one"; } },
                react_1.default.createElement(Formik_2.default, { antd: {
                        label: "Schedule",
                        required: true,
                        labelCol: { span: 24, offset: 0 },
                    }, options: SCHEDULES, optionType: "button", name: "schedule", buttonStyle: "solid" })),
            projectSelect,
            wasteFractionSelect,
            containerTypeSelect,
            depotStartSelect,
            depotEndSelect,
            wasteStationSelect,
            vehicleSelect,
            driverSelect,
            react_1.default.createElement(Button_1.default, { type: "primary", disabled: isSubmitting, title: "Next", onClick: submitForm })));
    }));
};
exports.default = CreateRouteSettings;
